export const isEmpty = (value) => value === '';
export const isNotEmpty = (value) => value !== '';
export const isPropertyEmpty = (property) => (value) => value[property] === '';
export const isPropertyNotEmpty = (property) => (value) => value[property] !== '';
export const arePropertiesEmpty = (...properties) => (value) => properties.every((property) => value[property] === '');
export const arePropertiesNotEmpty = (...properties) => (value) => properties.every((property) => value[property] !== '');
